import styled from 'styled-components'
import ripple from '../../../styles/animations/ripple'
import { down, up } from 'styled-breakpoints'

export const footerDocs = {
  Content: styled.div`
    gap: 5px;
    padding: 10px 15px;
    height: 80%;
    overflow-y: auto;
  `
}

export const Content = styled.div`
  display: flex;
  width: 100%;
`

export const GridStyles = {
  Content: styled.div`
    ${ripple}
    padding: 15px;
    display: flex;
    max-width: 110px;
    height: 130px;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
  `,
  Folder: styled.img`
    width: 81px;
    height: 68px;
  `,
  Name: styled.div`
    text-align: center;
    font-size: 12px;
    font-weight: 800;
    color: ${({ theme }) => theme.colors.title};
    overflow: hidden;
    white-space: break-spaces;
    word-break: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  `,
}

export const ListStyles = {
  Content: styled.div`
    padding: 0;
    flex: 1;
    overflow-y: auto;
    background-color: transparent;
  `,
  NameFile: styled.div<{ minWidth?: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-direction: row;
    padding: 0 8px;
    min-width: 0;
  `,
  Row: styled.div`
    ${ripple}
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: row;
    padding: 10px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    background-color: transparent;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: rgba(255, 255, 255, 0.35);
    }
  `,
  Folder: styled.img`
    width: 22px;
    height: 20px;
  `,
  Name: styled.div`
    font-size: 13px;
    font-weight: 500;
    color: #1e293b;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    white-space: normal;
    -webkit-box-orient: vertical;
  `,
}

export const LeftContent = styled.div`
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  width: 260px;
  min-width: 240px;
  max-width: 300px;
  padding: 16px 14px;
  height: calc(100% - 32px);
  margin: 16px 0 16px 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${down('md')} {
    display: none;
  }
`

export const ContentRight = styled.div`
  flex: 1;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.secondary || '#b8b8b8'};
  padding: 16px 20px 16px 14px;
  gap: 14px;

  ${down('md')} {
    width: 100%;
    padding: 10px;
  }
`

export const TableCard = styled.div`
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`

export const ContentRightBody = styled.div<{ isList: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

export const HeaderContent = {
  Content: styled.div`
    display: flex;
    padding: 14px 18px;
    flex-direction: column;
    background-color: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    gap: 12px;
  `,
  HeaderContent: styled.div``,
  ButtonList: styled.div`
    ${ripple}
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    margin-left: auto;
    img {
      width: 31px;
      height: 31px;
    }
    color: #475569;
  `,
  Columns: styled.div`
    display: flex;
    background-color: rgba(255, 255, 255, 0.25);
    border-bottom: 2px solid rgba(0, 0, 0, 0.08);
    overflow: auto;
    width: 100%;
    align-items: center;
    flex-direction: row;
    padding: 10px 16px;

    ${up('md')} {
      overflow: hidden;
    }
  `,
  ColumnName: styled.div`
    ${ripple}
    cursor: pointer;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    display: flex;
    align-items: center;
    flex-direction: row;
    color: ${({ theme }) => theme.colors.primary || '#2c30af'};
  `,
  BreadCumbs: styled.div`
    flex-direction: row;
    display: flex;
    align-items: center;
    overflow: auto;
    white-space: nowrap;
    gap: 6px;
  `,
  BreadName: styled.div`
    color: ${({ theme }) => theme.colors.primary || '#2c30af'};
    font-weight: 700;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  `,
}

export const HomeStyles = {
  Row: styled.div`
    ${ripple}
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    padding: 4px 6px;
    border-radius: 6px;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #f1f5f9;
    }
  `,
  ContentInner: styled.div`
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  `,
  BreadName: styled.div`
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    flex-direction: row;
    color: #0f172a;
  `,
  Label: styled.div`
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
  `,
}
